"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("composer-lib/lib/constants");

var _User = _interopRequireDefault(require("./User"));

function parseUsers(data) {
  var result = new _immutable.OrderedMap();
  data.forEach(function (userItem) {
    var user = _User.default.fromJS(userItem);

    result = result.set(user.get('id'), user);
  });
  return result;
}

var DEFAULTS = {
  status: _constants.RequestStatus.UNINITIALIZED,
  data: new _immutable.OrderedMap()
};

var Users = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Users, _Record);

  function Users() {
    (0, _classCallCheck2.default)(this, Users);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Users).apply(this, arguments));
  }

  (0, _createClass2.default)(Users, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new Users({
        data: parseUsers(data),
        status: _constants.RequestStatus.SUCCEEDED
      });
    }
  }]);
  return Users;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Users;
module.exports = exports.default;